import { SharedModule } from '../shared/shared.module';
import { NotificationsComponent } from './notifications.component';
import { NotificationService } from './shared/services/notifications.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialUserInterfaceModule } from 'ng2-material-components/ng2-material-components';
import { StripHTMLPipe } from './strip-html.pipe';
import { LinkifyPipe } from '../shared/pipes';

@NgModule({
    imports: [
        CommonModule,
        MaterialUserInterfaceModule,
        SharedModule,
    ],
    exports: [
        NotificationsComponent,
    ],
    declarations: [
        NotificationsComponent,
        StripHTMLPipe,
        LinkifyPipe
        ],
    providers: [NotificationService],
})
export class NotificationsModule { }




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/notifications/notifications.module.ts